module.exports = __webpack_public_path__ + "static/media/coy_logo.bc481bcb.png";